import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoBasesDatosIndexadasDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoBasesDatosIndexadasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoBasesDatosIndexadasService(): Observable<BodyListResponse<CatalogoBasesDatosIndexadasDTO>> {
    return this.http.get<BodyListResponse<CatalogoBasesDatosIndexadasDTO>>(API_URL + '/api/v1/catalogoBasesDatosIndexadas/todos');
  }

  guardarCatalogoBasesDatosIndexadasService(catalogoBasesDatosIndexadasDTO: CatalogoBasesDatosIndexadasDTO): Observable<BodyResponse<CatalogoBasesDatosIndexadasDTO>> {
    return this.http.post<BodyResponse<CatalogoBasesDatosIndexadasDTO>>(API_URL + '/api/v1/catalogoBasesDatosIndexadas', catalogoBasesDatosIndexadasDTO);
  }

  getCatalogoBasesDatosIndexadasPorCodigoCatalogoBasesDatosIndexadasService(codigoCatalogoBasesDatosIndexadas: string): Observable<BodyResponse<CatalogoBasesDatosIndexadasDTO>> {
    return this.http.get<BodyResponse<CatalogoBasesDatosIndexadasDTO>>(API_URL + '/api/v1/catalogoBasesDatosIndexadas/' + codigoCatalogoBasesDatosIndexadas);
  }
}
